export default __webpack_public_path__ + "ba29b7ac8e2f0047db8048447ab4d836.svg";